import axios from "axios";

const serviceRootUrl = (tenantId) => `/api/${tenantId}/entities`;

export function getAll(tenantId) {
  return axios.get(serviceRootUrl(tenantId));
}

export function upsert(tenantId, path, entity) {
  return axios.post(`${serviceRootUrl(tenantId)}?path=${path}`, entity);
}

export function remove(tenantId, path) {
  return axios.delete(`${serviceRootUrl(tenantId)}?path=${path}`);
}

export function upload({ tenantId, file }) {
  let formData = new FormData();
  formData.append("file", file);

  return axios.post(`${serviceRootUrl(tenantId)}/upload`, formData);
}

export default { getAll, upsert, remove, upload };

// Some rando comment
